import { axiosInstance } from "api/axios-config/axios-config";
import { Pagination } from "api/models/response/pagination";
import { ICatalogueProperties } from "mobx-stores/_models/base";
import { IUpdateContractInsurance } from "mobx-stores/_models/employee/contract-insurance";
import {
  IAddEmployee,
  IEmployeeDetailProperties,
  IEmployeeProperties,
  IUpdateEmployee,
} from "mobx-stores/_models/employee/employee";
import { IUpdateExtraInfomation } from "mobx-stores/_models/employee/extra-infomation";
import { IEnumApi } from "mobx-stores/_models/enum-api";
import { BaseBussiness } from "../base";

class EmployeeBussiness extends BaseBussiness<
  IEmployeeProperties,
  IAddEmployee,
  IUpdateEmployee,
  IEmployeeDetailProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public getGender = async () => {
    try {
      var res = await axiosInstance.get<IEnumApi[]>(this.url + "/gender");
      return res.data;
    } catch (error) {
      console.error("Fail getGender", error);
      return Promise.reject(error);
    }
  };

  public getEmploymentContractType = async () => {
    try {
      var res = await axiosInstance.get<IEnumApi[]>(
        this.url + "/contract-type"
      );
      return res.data;
    } catch (error) {
      console.error("Fail getEmploymentContractType", error);
      return Promise.reject(error);
    }
  };

  public getEmploymentContractTermType = async () => {
    try {
      var res = await axiosInstance.get<IEnumApi[]>(
        this.url + "/contract-term-type"
      );
      return res.data;
    } catch (error) {
      console.error("Fail getEmploymentContractTermType", error);
      return Promise.reject(error);
    }
  };

  public getRecruitmentResource = async () => {
    try {
      var res = await axiosInstance.get<IEnumApi[]>(
        this.url + "/recruitment-source-type"
      );
      return res.data;
    } catch (error) {
      console.error("Fail getRecruitmentResource", error);
      return Promise.reject(error);
    }
  };

  public getEmploymentStatus = async () => {
    try {
      var res = await axiosInstance.get<IEnumApi[]>(
        this.url + "/employment-status"
      );
      return res.data;
    } catch (error) {
      console.error("Fail getEmploymentStatus", error);
      return Promise.reject(error);
    }
  };

  public getDepartmentTypes = async () => {
    try {
      var res = await axiosInstance.get<Pagination<ICatalogueProperties>>(
        this.url + "/department-type"
      );
      return res.data;
    } catch (error) {
      console.error("Fail getDepartmentType", error);
      return Promise.reject(error);
    }
  };

  public updateContractInsurance = async (
    employeeId: string,
    req: IUpdateContractInsurance
  ) => {
    try {
      var res = await axiosInstance.put(
        this.url + `/${employeeId}/contract-insurance`,
        req
      );
      return res.data;
    } catch (error) {
      console.error("Fail updateContractInsurance", error);
      return Promise.reject(error);
    }
  };

  public updateInformation = async (
    employeeId: string,
    req: IUpdateExtraInfomation
  ) => {
    try {
      var res = await axiosInstance.put(
        this.url + `/${employeeId}/information`,
        req
      );
      return res.data;
    } catch (error) {
      console.error("Fail updateInformation", error);
      return Promise.reject(error);
    }
  };

  public addEmployeeAsForm = async (
    data: IAddEmployee,
    avatar: File | null
  ) => {
    try {
      const formData = new FormData();
      formData.append("code", data.code || "");
      formData.append("fullName", data.fullName || "");
      formData.append("departmentTypeId", data.departmentTypeId || "");
      formData.append("position", data.position || "");
      formData.append("level", data.level || "");
      formData.append("qualification", data.qualification || "");
      formData.append("gender", data.gender?.toString() || "");
      formData.append("branch", data.branch || "");
      formData.append("note", data.note || "");
      formData.append("avatar", avatar || "");
      var res = await axiosInstance.post(this.url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (error) {
      console.error("Fail addEmployeeAsForm", error);
      return Promise.reject(error);
    }
  };

  public updateEmployeeAsForm = async (
    id: string,
    data: IUpdateEmployee,
    avatar: File | null
  ) => {
    try {
      const formData = new FormData();
      formData.append("code", data.code || "");
      formData.append("fullName", data.fullName || "");
      formData.append("departmentTypeId", data.departmentTypeId || "");
      formData.append("position", data.position || "");
      formData.append("level", data.level || "");
      formData.append("qualification", data.qualification || "");
      formData.append("gender", data.gender?.toString() || "");
      formData.append("branch", data.branch || "");
      formData.append("note", data.note || "");
      formData.append("avatar", avatar || "");
      var res = await axiosInstance.put(this.url + "/" + id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (error) {
      console.error("Fail addEmployeeAsForm", error);
      return Promise.reject(error);
    }
  };

  public getAvatar = async (name: string): Promise<File> => {
    try {
      var res = await axiosInstance.get(this.url + "/avatar/" + name, {
        responseType: "blob",
      });
      return res.data;
    } catch (error) {
      console.error("Fail getAvatar", error);
      return Promise.reject(error);
    }
  };
}

export const employeeBussiness = new EmployeeBussiness("/api/app/employee");
